import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import moment from 'moment';
import { ModelService } from '../../../../core/services/model/model.service';
import { AlertService } from '../../../../core/services/alert/alert.service';
import { OrdersService } from '../../../../core/services/orders/orders.service';
import { Router, RouterModule } from '@angular/router';
import { copyToClipboard as copyToClipboardUtil } from '../../../../core/utils/clipboard.utils';
import { FUEL_OPTIONS, TRANSMISSION_OPTIONS, DRIVETRAIN_OPTIONS, EMISSIONS_LABEL_OPTIONS } from '../../../../core/constants/vehicle-taxonomies.constants';



@Component({
  selector: 'app-vehicle-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    RouterModule,
    NgSelectModule,
    CommonModule],
  templateUrl: './vehicle-form.component.html',
  styleUrl: './vehicle-form.component.css'
})
export class VehicleFormComponent {
  @Input() stockData?: any;
  @Input() stockPreData?: any; // Datos de precarga para nuevos stocks
  @Input() ladata: any = [];
  @Output() emitDuplicate = new EventEmitter<boolean>();
  @Output() emitChangeBrand = new EventEmitter<string>();

  vehicleForm: FormGroup;
  models: any[] = [];
  brands: any[] = [];
  fuelOptions = FUEL_OPTIONS;
  transmissionOptions = TRANSMISSION_OPTIONS;
  drivetrainOptions = DRIVETRAIN_OPTIONS;
  emissionsLabelOptions = EMISSIONS_LABEL_OPTIONS;

  vehicle_model_id_ = '';
  showAlertLicensePlate = false;
  urlLicensePlate = '';
  showAlertVin = false;
  urlVin = '';
  dealershipData: any = [];
  constructor(private fb: FormBuilder, private modelService: ModelService, private alertService: AlertService, private orderService: OrdersService, private router: Router) {
    this.vehicleForm = this.fb.group({
      vehicle_discount_code: ['', Validators.required],
      colour: ['', Validators.required],
      vehicle: ['', Validators.required],
      vehicle_brand_id: ['', Validators.required],
      vehicle_model_id: ['', Validators.required],
      vehicle_model_year: ['', Validators.required],
      vehicle_trim: ['', Validators.maxLength(150)],
      vehicle_status: ['', Validators.required],
      vehicle_registered: ['', Validators.required],
      fuel: ['', Validators.required],
      transmission: ['', Validators.required],
      drivetrain: ['', Validators.required],
      emissions_label: ['', Validators.required],
      power: [null, [Validators.required, Validators.min(1)]],
      doors: [null, [Validators.required, Validators.min(1)]],
      seats: [null, [Validators.required, Validators.min(1)]],
      equipment: [''],
    });
  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes['ladata']) {
        this.brands = this.ladata.brands;
        this.dealershipData = this.ladata.dealershipData;
      }

      if (changes['stockData']) {
        if (this.stockData) {
          this.refrescarFormulario();
        }
      }

      // Si cambia stockPreData y no hay stockData (modo agregar), usar stockPreData
      if (changes['stockPreData']) {
        if (this.stockPreData && !this.stockData) {
          this.refrescarFormulario();
        }
      }
    }
  }


  async refrescarFormulario() {
    this.updateFieldAccessibility();

    // Determinar qué datos usar: stockData para editar, stockPreData para agregar
    const dataToUse = this.stockData || this.stockPreData;

    if (!dataToUse) return;

    // Si hay una marca seleccionada y no hay modelos cargados, cargarlos primero
    if (this.models.length === 0 && dataToUse.vehicle_brand_id) {
      await this.onBrandChange(dataToUse.vehicle_brand_id);
    }

    // Establecer todos los valores del formulario
    for (const key in dataToUse) {
      const control = this.vehicleForm.controls[key];
      const value = dataToUse[key];

      if (control) {
        switch (key) {
          case 'vehicle_registered':
            // Convertir 0/"0" a false (unchecked) y 1/"1" a true (checked)
            control.setValue(value == 1 || value == '1');
            break;
          default:
            control.setValue(value);
            break;
        }
      }
    }
    this.alertService.close();
  }

  async onBrandChange(value: any) {
    if (!value) return;
    var brand_reference: any = '';
    if (typeof value === 'string') {
      brand_reference = value;
    } else {
      brand_reference = value.target.value;
    }

    // Determinar qué datos usar: stockData para editar, stockPreData para agregar
    const dataToUse = this.stockData || this.stockPreData;

    try {
      const data = await this.modelService.getDataByBrand(brand_reference).toPromise();
      this.models = data.data;
      if (brand_reference != dataToUse?.vehicle_brand_id) {
        this.vehicleForm.get('vehicle_model_id')?.setValue('');
      }
    } catch (error) {
      console.error('There was an error!', error);
    }

    if (!dataToUse?.vehicle_brand_id) {
      this.emitChangeBrand.emit(brand_reference);
    }

  }

  updateFieldAccessibility() {
    // Determinar qué datos usar: stockData para editar, stockPreData para agregar
    const dataToUse = this.stockData || this.stockPreData;
    const flagRules = this.stockPreData ? false : true; // Si hay stockPreData, no usar reglas para deshabilitar campos
    var rules = dataToUse?.rules;

    if (flagRules) {
      // Deshabilitar todos los campos por defecto
      for (const field in this.vehicleForm.controls) {
        if (this.vehicleForm.controls.hasOwnProperty(field)) {
          this.vehicleForm.get(field)?.disable();
        }
      }

      // Habilitar solo los campos con valor 'w' en las reglas
      for (const field in rules) {
        if (rules.hasOwnProperty(field) && rules[field] === 'w') {
          this.vehicleForm.get(field)?.enable();
        }
      }
    }
  }

  checkUpdateForm(): boolean {
    if (this.vehicleForm.dirty) {
      return true;
    } else {
      return false;
    }
  }
  copyToClipboard(value: string, event: Event): void {
    copyToClipboardUtil(value, event);
  }

  duplicate() {
    this.emitDuplicate.emit(true);
  }

  fillVehicleFormForHelper(option: any) {
    this.vehicleForm.get('vehicle_model_id')?.setValue(option['vehicle_model_id']);
    this.vehicleForm.get('vehicle')?.setValue(option['vehicle']);
    this.vehicleForm.get('vehicle_status')?.setValue(option['vehicle_status']);
    this.vehicleForm.get('vehicle_units')?.setValue(option['vehicle_units']);
    this.vehicleForm.get('vehicle_model_year')?.setValue(option['vehicle_model_year']);
    this.vehicleForm.get('colour')?.setValue(option['colour']);
    this.vehicleForm.get('vehicle_trim')?.setValue(option['vehicle_trim']);
  }

  async onBlurVin(value: string) {
    try {
      // Solo verificar duplicados si estamos editando un stock existente
      const stockReference = this.stockData?.reference || null;
      const data = await this.orderService.checkVin(stockReference, value).toPromise();
      if (data.data) {
        this.showAlertVin = true;
        this.urlVin = data.data.url;
      }
    } catch (error) {
      console.error('There was an error!', error);
    }
  }

  async onBlurLicensePlate(value: string) {
    try {
      // Solo verificar duplicados si estamos editando un stock existente
      const stockReference = this.stockData?.reference || null;
      const data = await this.orderService.checkLicensePlate(stockReference, value).toPromise();
      if (data.data) {
        this.showAlertLicensePlate = true;
        this.urlLicensePlate = data.data.url;
      }
    } catch (error) {
      console.error('There was an error!', error);
    }
  }


}
